import { useEffect, useState } from 'react';
import './RecordingOverlay.css';

interface RecordingOverlayProps {
    isRecording: boolean;
    progress: number; // 0-100
}

export default function RecordingOverlay({ isRecording, progress }: RecordingOverlayProps) {
    const [dots, setDots] = useState('');
    
    // Animate dots
    useEffect(() => {
        if (!isRecording) return;
        
        const interval = setInterval(() => {
            setDots(prev => prev.length >= 3 ? '' : prev + '.');
        }, 500);
        
        return () => clearInterval(interval);
    }, [isRecording]);
    
    if (!isRecording) return null;
    
    return (
        <div className="recording-overlay">
            <div className="recording-modal">
                <div className="recording-icon">
                    <div className="recording-pulse"></div>
                    <div className="recording-dot"></div>
                </div>
                
                <h2>Recording 360° Video{dots}</h2>
                <p>Please wait while we capture your product</p>
                
                <div className="progress-bar">
                    <div 
                        className="progress-fill" 
                        style={{ width: `${progress}%` }}
                    ></div>
                </div>
                
                <span className="progress-text">{Math.round(progress)}%</span>
                
                <p className="recording-note">
                    Do not interact with the model during recording
                </p>
            </div>
        </div>
    );
}
